/**
 * entityType Normalizr Schema
 */

import { schema } from 'normalizr';

const entityType = new schema.Entity('entityTypes');

export default entityType;
